import { useEffect, useRef } from 'react';
import './IronTailAnimation.css';

export default function IronTailAnimation({ onComplete, playerRef, opponentRef }) {
  const elementsRef = useRef([]);

  useEffect(() => {
    const playerEl = playerRef.current;
    const opponentEl = opponentRef.current;
    if (!playerEl || !opponentEl) return;

    const container = playerEl.parentElement;
    const pRect = playerEl.getBoundingClientRect();
    const oRect = opponentEl.getBoundingClientRect();
    const cRect = container.getBoundingClientRect();

    const startX = pRect.left - cRect.left + pRect.width / 2;
    const startY = pRect.top - cRect.top + pRect.height / 2;
    const endX = oRect.left - cRect.left + oRect.width / 2;
    const endY = oRect.top - cRect.top + oRect.height / 2;

    const elements = [];

    // Phase 1: Charge up
    playerEl.classList.add('iron-tail-charge');

    // Phase 2: Tail Arc
    const arcTime = 700;
    const arc = document.createElement('div');
    arc.className = 'iron-tail-arc';
    arc.style.left = `${startX}px`;
    arc.style.top = `${startY}px`;
    arc.style.setProperty('--tx', `${endX - startX}px`);
    arc.style.setProperty('--ty', `${endY - startY}px`);
    container.appendChild(arc);
    elements.push(arc);

    // Phase 3: Impact
    const impactTime = arcTime - 150;
    const impactTimer = setTimeout(() => {
      opponentEl.classList.add('iron-tail-hit');

      const shockwave = document.createElement('div');
      shockwave.className = 'iron-tail-shockwave';
      shockwave.style.left = `${endX}px`;
      shockwave.style.top = `${endY}px`;
      container.appendChild(shockwave);
      elements.push(shockwave);

      for (let i = 0; i < 15; i++) {
        const shard = document.createElement('div');
        shard.className = 'iron-tail-shard';
        shard.style.left = `${endX}px`;
        shard.style.top = `${endY}px`;
        const angle = Math.random() * 360;
        const distance = 80 + Math.random() * 40;
        shard.style.setProperty('--dx', `${Math.cos(angle * Math.PI / 180) * distance}px`);
        shard.style.setProperty('--dy', `${Math.sin(angle * Math.PI / 180) * distance}px`);
        shard.style.setProperty('--angle', `${angle}deg`);
        shard.style.animationDelay = `${Math.random() * 0.15}s`;
        container.appendChild(shard);
        elements.push(shard);
      }
    }, impactTime);

    // Cleanup
    const cleanupTime = impactTime + 1200;
    const cleanupTimer = setTimeout(() => {
      elements.forEach(el => el.remove());
      playerEl.classList.remove('iron-tail-charge');
      opponentEl.classList.remove('iron-tail-hit');
      onComplete();
    }, cleanupTime);

    elementsRef.current = elements;

    return () => {
      clearTimeout(impactTimer);
      clearTimeout(cleanupTimer);
      elementsRef.current.forEach(el => el.remove());
      if (playerEl) playerEl.classList.remove('iron-tail-charge');
      if (opponentEl) opponentEl.classList.remove('iron-tail-hit');
    };
  }, [onComplete, playerRef, opponentRef]);

  return null;
}

IronTailAnimation.moveType = 'steel';
